import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import zeplinColor from '../../../theme/Color';

type TeamMetrics = {
  workloadCapacity: number;
  activeClients: number;
  totalDeals: number;
  totalTasks: number;
};

const TeamMetricsGrid = ({ metrics }: { metrics: TeamMetrics }) => {
  const isOverCapacity = metrics.workloadCapacity > 100;

  const items = [
    {
      title: 'Workload Capacity',
      value: `${metrics.workloadCapacity}%`,
      extra: isOverCapacity ? (
        <Chip
          label='Over Capacity'
          size='small'
          sx={{
            backgroundColor: zeplinColor.Error,
            color: zeplinColor.Neutral1,
            height: '20px',
            '& .MuiChip-label': { px: '8px' },
          }}
        />
      ) : null,
    },
    { title: 'Active Clients', value: metrics.activeClients, extra: null },
    { title: 'Total Deals', value: metrics.totalDeals, extra: null },
    { title: 'Total Tasks', value: metrics.totalTasks, extra: null },
  ];

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr 1fr', xl: 'repeat(4, 1fr)' },
        gap: '12px',
      }}
    >
      {items.map((item) => (
        <Box
          key={item.title}
          sx={{
            borderRadius: '12px',
            border: `1px solid ${zeplinColor.Neutral5}`,
            p: '12px',
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            backgroundColor: zeplinColor.Neutral1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              flexWrap: 'wrap',
              flex: 1,
              justifyContent: 'space-between',
            }}
          >
            <Typography
              variant='responsiveHeading3'
              color={
                isOverCapacity && item.title === 'Workload Capacity'
                  ? zeplinColor.Error
                  : zeplinColor.BasicBlack
              }
            >
              {item.value}
            </Typography>
            {item.extra}
          </Box>
          <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
            {item.title}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default TeamMetricsGrid;
